const COOKIEE_REDUX_CONSTANT = {
  GET_COOKIEE: 'GET_COOKIEE',
};
export default COOKIEE_REDUX_CONSTANT;
